import { render, staticRenderFns } from "./AssetLanding.vue?vue&type=template&id=efaaecb4&scoped=true&"
import script from "./AssetLanding.vue?vue&type=script&lang=js&"
export * from "./AssetLanding.vue?vue&type=script&lang=js&"
import style0 from "./AssetLanding.vue?vue&type=style&index=0&id=efaaecb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaaecb4",
  null
  
)

export default component.exports